<script>
import Layout from '@/views/layouts/main';
import appConfig from '@/app.config';
import Swal from 'sweetalert2';
import Multiselect from '@/components/Multiselect/main.vue';
import KeyWordTag from '@/components/KeywordTag/main.vue';
import TableListComponent from '@/components/TableList/main.vue';
import ButtonActiveFilter from '@/components/ButtonColFilter/main.vue';

import { masterMethods, faqMethods } from '@/state/helpers';
import { checkPermission } from '@/utils/handlers';
import { keyMaster } from '@/config/constants';
import { truncateText } from '@/utils/format';
import { showMessage } from '@/utils/messages';
import { InputRadio } from '@/components/Input';

export default {
    page: {
        title: 'FAQ管理一覧',
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        Layout,
        KeyWordTag,
        Multiselect,
        InputRadio,
        TableListComponent,
        ButtonActiveFilter
    },
    beforeRouteEnter(to, from, next) {
        if (!checkPermission('faq.view')) {
            next({ name: 'errorPage' });
        }
        next();
    },
    data() {
        return {
            listData: [],
            listDataAnswer: [],
            listDataCPTypes: [],
            listSheetFAQ: [],
            listApplicationType: [],
            form: {
                question: '',
                keywords: ''
            },
            dataAnswerObj: {},
            has: {
                category_id: ''
            },
            filter: {
                sheet: '',
                campaign_type: ''
            },
            configKeyword: {
                arrayTag: [],
                placeholder: '質問　回答',
                isShowLable: true
            },
            dataAnswer: {
                answer: '',
                faq_id: 3
            },
            configTable: {
                widthAction: 200,
                headers: [
                    {
                        label: 'No',
                        width: 40
                    },
                    {
                        label: this.$t('faq.question'),
                        width: 600
                    },
                    {
                        label: this.$t('faq.campaignType'),
                        width: 120
                    },
                    {
                        label: this.$t('faq.applicationType'),
                        width: 250
                    }
                ]
            },
            configPage: {
                total: 0,
                limit: 10,
                page: 1
            },
            checkShowFilter: false,
            isLoading: false,

            isActive: true,
            heightSizeTable: ''
        };
    },
    watch: {},
    mounted() {
        this.getList();
        this.getListMasterTypes();
        this.getListMasterSheets();
    },

    methods: {
        ...masterMethods,
        ...faqMethods,
        checkPermiss(listRole) {
            return checkPermission(listRole);
        },
        truncateTextTable(text) {
            return truncateText(text);
        },

        getListMasterSheets() {
            this.listMaster(keyMaster['faq_master.sheets']).then((data) => {
                this.listSheetFAQ = data;
            });
        },
        getListMasterTypes() {
            this.listMaster(keyMaster['campaign.type']).then((data) => {
                this.listDataCPTypes = data;
            });
        },
        handleShowFilter() {
            this.checkShowFilter = !this.checkShowFilter;
        },
        getDetail(id) {
            this.loading = true;
            this.detailFaq(id).then((data) => {
                this.listDataAnswer = data.answers;
                this.dataAnswerObj = data;
                this.loading = false;
                this.dataAnswer.faq_id = data.id;
            });
        },

        goToEdit(path, item) {
            this.$router.push({ path: path, query: { id: item.id } });
        },
        getQueryString() {
            let query = [`page=${this.configPage.page}`, `limit=${this.configPage.limit}`, `sorts[id]=desc`];

            if (this.checkShowFilter) {
                if (this.form) {
                    for (const [key, value] of Object.entries(this.form)) {
                        if (key && value) query.push(`search[${key}]=${value}`);
                    }
                }
                if (this.filter) {
                    for (const [key, value] of Object.entries(this.filter)) {
                        if (key && value) {
                            if (key === 'sheet') {
                                query.push(`filters[${key}]=${value.id}`);
                            } else {
                                query.push(`filters[${key}]=${value}`);
                            }
                        }
                    }
                }
                if (this.has) {
                    for (const [key, value] of Object.entries(this.has)) {
                        if (key && value) {
                            if (key === 'category_id') {
                                if (value.length) {
                                    query.push(`has[${key}]=${value.map((item) => item.id.toString())}`);
                                }
                            } else {
                                query.push(`has[${key}]=${value}`);
                            }
                        }
                    }
                }
            } else {
                if (this.configKeyword.arrayTag.length > 0) {
                    query.push(`q=${this.configKeyword.arrayTag.toString()}`);
                }
            }

            return query.join('&');
        },
        getList() {
            this.isLoading = true;
            let query = this.getQueryString();
            this.listFaqs(query).then((data) => {
                this.listData = data.data;
                this.configPage.total = data._metadata.total;
                this.configPage.limit = data._metadata.limit * 1;
                if (!this.listData.length && this.configPage.page !== 1) {
                    this.configPage.page = 1;
                    this.getList();
                } else {
                    this.isLoading = false;
                }
            });
        },

        onChangeCPType() {
            this.listApplicationType = this.listDataCPTypes.find((item) => item.id === this.filter.campaign_type)?.data;
            this.has.category_id = [];
        },
        search() {
            this.getList();
        },
        clear() {
            this.form = {
                keywords: '',
                question: ''
            };
            this.filter = {
                sheet: '',
                campaign_type: ''
            };
            this.has = {
                category_id: []
            };
            this.configKeyword.arrayTag = [];
            this.getList();
        },

        deleteObjectFaq(data) {
            Swal.fire({
                title: 'このFAQ を削除してもよろしいですか。',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#5664d2',
                cancelButtonColor: '#EFF2F7',
                confirmButtonText: 'OK',
                cancelButtonText: 'キャンセル'
            }).then((result) => {
                if (result.value) {
                    this.deleteFaq(data).then((data) => {
                        if (data.code == 200) {
                            showMessage(data.code, this.$bvToast, 'FAQが削除されました。');
                        } else {
                            showMessage(data.code, this.$bvToast, this.$t(data.message));
                        }
                    });
                }
            });
        },

        register() {
            if (this.dataAnswer.answer && this.dataAnswer.faq_id) {
                this.registerAnswer(this.dataAnswer).then((data) => {
                    if (data.code == 200) {
                        this.dataAnswer.answer = '';
                        this.getDetail(this.dataAnswer.faq_id);
                        showMessage(data.code, this.$bvToast, 'Success');
                    }
                });
            }
        },
        edit(item) {
            if (item.answer) {
                let data = Object.assign(item);
                this.updateAnswer(data).then(() => {
                    showMessage(data.code, this.$bvToast, 'Success');
                });
            }
        },
        setDefault(item) {
            if (item.answer) {
                let data = {
                    answer_default: item.id,
                    id: this.dataAnswer.faq_id
                };
                this.updateFaqsAnswerDefault(data).then(() => {
                    this.getDetail(this.dataAnswer.faq_id);
                    showMessage(data.code, this.$bvToast, 'Success');
                });
            }
        },
        renderTextCPType(params) {
            return this.listDataCPTypes.find((item) => item.id === params)?.value;
        },
        renderTextApplicationType(params) {
            if (params) return params.map((item) => item.category.value).join(', ');
            return '';
        }
    }
};
</script>

<template>
    <Layout>
        <div class="row form__common--center">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header d-flex" style="gap: 0.5rem">
                        <h3 class="mb-0 title--screen">FAQ検索</h3>
                        <div class="ml-auto">
                            <ButtonActiveFilter
                                :active.sync="isActive"
                                @sizeHeight="(height) => (heightSizeTable = height)"
                                :smallCol="577"
                                :largeCol="53.9"
                            />
                        </div>
                    </div>
                    <div v-if="isActive" class="card-body position-relative">
                        <div class="row justify-content-center">
                            <div class="col-sm-6 position-static">
                                <form class="needs-validation" autocomplete="off">
                                    <div v-if="!checkShowFilter" class="row form-group">
                                        <div class="col-sm-12">
                                            <KeyWordTag :keyword="form.keywords" :config="configKeyword" class="flex-fill" />
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="form-group">
                                            <label class="col-sm-2 mw--form" for="validationCustom05">{{ $t('faq.searchSheet') }}</label>
                                            <div class="w-100">
                                                <Multiselect
                                                    :id="`select-filter-sheet`"
                                                    :value.sync="filter.sheet"
                                                    :options="listSheetFAQ"
                                                    :config="{
                                                        error: false,
                                                        isRemove: false,
                                                        trackBy: 'value',
                                                        label: 'value',
                                                        loading: false
                                                    }"
                                                />
                                            </div>
                                        </div>
                                        <div class="form-group d-flex">
                                            <label class="col-sm-2 mw--form" for="validationCustom05">{{ $t('faq.campaignType') }} </label>
                                            <div class="w-100">
                                                <div class="d-flex">
                                                    <div v-for="cpt in listDataCPTypes" :key="cpt.id + 's'">
                                                        <InputRadio
                                                            class="mr-4"
                                                            :model.sync="filter.campaign_type"
                                                            :id="`radio${cpt.id}`"
                                                            :value="cpt.id"
                                                            :label="cpt.value"
                                                            @change="onChangeCPType"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="col-sm-2 mw--form" for="validationCustom05">{{ $t('faq.applicationType') }}</label>
                                            <div class="w-100">
                                                <Multiselect
                                                    :id="`select-has-category_id`"
                                                    :value.sync="has.category_id"
                                                    :options="listApplicationType"
                                                    :config="{
                                                        error: false,
                                                        isRemove: false,
                                                        trackBy: 'value',
                                                        label: 'value',
                                                        loading: false
                                                    }"
                                                />
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="col-sm-2 mw--form" for="validationCustom05">{{ $t('faq.question') }}</label>
                                            <div class="w-100">
                                                <textarea id="validationCustom05" v-model="form.question" class="form-control" />
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div class="text-center mt-4">
                                        <button type="button" @click="clear()" class="btn btn-common btn-outline-primary">
                                            <i class="ri-restart-line"></i>{{ $t('btn.clear') }}
                                        </button>
                                        <button type="button" @click="search()" class="btn btn-common btn-primary ml-3">
                                            <i class="ri-search-line"></i>{{ $t('btn.search') }}
                                        </button>
                                        <button type="button" @click="handleShowFilter" class="btn btn-common filter btn-outline-primary">
                                            <i class="ri-equalizer-line"></i>絞り込み条件を表示
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mb-0">
                    <div class="card-header">
                        <h3 class="mb-0 title--screen">FAQ検索結果</h3>
                    </div>
                    <div class="card-body">
                        <TableListComponent
                            :heightTable="heightSizeTable"
                            :config="configTable"
                            :dataList="listData"
                            :isLoading="isLoading"
                            :configPage.sync="configPage"
                            :stickyAction="true"
                            @onChangePage="getList()"
                        >
                            <template #row="{ row, index }">
                                <tr @dblclick="goToEdit('/faq/view', row)">
                                    <td>
                                        <div class="el-table__cell text-left">
                                            {{ index }}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="el-table__cell text-left" v-b-tooltip.hover :title="row.question">
                                            {{ truncateTextTable(row.question) }}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="el-table__cell text-left">
                                            {{ row.campaign_type ? row.campaign_type.value : '' }}
                                        </div>
                                    </td>
                                    <td>
                                        <div
                                            class="el-table__cell text-left"
                                            v-b-tooltip.hover
                                            :title="renderTextApplicationType(row.categories) ?? ''"
                                        >
                                            {{ renderTextApplicationType(row.categories) }}
                                        </div>
                                    </td>

                                    <td class="sticky_action text-left" style="z-index: 15">
                                        <div class="el-table__cell text-left">
                                            <a href="javascript:void(0)" class="btn btn-common-sml btn-info mr-2" @click="goToEdit('/faq/view', row)"
                                                ><i class="ri-file-list-2-line"></i>{{ $t('btn.detail') }}</a
                                            >
                                            <a
                                                v-if="checkPermiss('faq.edit')"
                                                href="javascript:void(0)"
                                                class="btn btn-common-sml btn-primary mr-2"
                                                @click="goToEdit('/faq/form', row)"
                                                ><i class="ri-edit-box-line"></i>{{ $t('btn.edit') }}</a
                                            >
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </TableListComponent>

                        <b-modal id="modal-lg" size="lg" title="回答 新規登録・編集" title-class="font-24" hide-footer>
                            <template>
                                <div v-for="(item, k) in listDataAnswer" class="d-flex align-items-center justify-content-center mb-3" :key="item.id">
                                    <span style="white-space: nowrap" class="mr-3">回答{{ k + 1 }}</span>
                                    <input v-model="item.answer" type="text" class="form-control" />
                                    <button type="button" @click="edit(item)" class="btn btn-info ml-2" style="white-space: nowrap">登録</button>

                                    <button
                                        type="button"
                                        v-if="dataAnswerObj.answer_default == item.id"
                                        @click="setDefault(item)"
                                        class="btn btn-success"
                                        style="white-space: nowrap"
                                    >
                                        Default
                                    </button>
                                    <button
                                        type="button"
                                        v-else
                                        @click="setDefault(item)"
                                        class="btn btn-outline-success"
                                        style="white-space: nowrap"
                                    >
                                        Default
                                    </button>
                                </div>
                            </template>

                            <hr />
                            <label for="">新規登録</label>
                            <input v-model="dataAnswer.answer" type="text" :maxlength="25" class="form-control" />
                            <div class="text-center mt-4">
                                <button type="button" @click="register()" class="btn btn-primary">登録</button>
                            </div>
                        </b-modal>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style lang="scss" scoped>
td,
th {
    vertical-align: middle;
}
</style>
